import { createBrowserHistory } from 'history';
import Tracker from 'core/api/tracking/tracker';

export const history = createBrowserHistory();

history.listen((location) => {
  Tracker.trackPageView();
  const isSwapConfirmation = location.pathname.startsWith('/onramp/confirmation/');
  if (window?.TriplePixel && !isSwapConfirmation) window.TriplePixel('pageLoad');
});

export default history;
